import B2BAPI from './B2BAPI'

export const getCampaigns = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaign = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.get(`/campaign/${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createCampaign = async (payload) => {
  try {
    const response = await B2BAPI.post('/campaign', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getFirms = async (params) => {
  try {
    const response = await B2BAPI.get('/firms', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRegistryFirms = async (apiController, params) => {
  try {
    const response = await B2BAPI.get('/registry-firms/paginate', {
      params: {
        ...params
      },
      signal: apiController.signal
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getTemplates = async (params) => {
  try {
    const response = await B2BAPI.get('/email-template', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const selectFirms = async (payload) => {
  try {
    const response = await B2BAPI.post('/select-firms', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const sendEmailReply = async (payload) => {
  try {
    const response = await B2BAPI.post('/send-reply', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getMessages = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign/messages', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const receive = async (params) => {
  try {
    const response = await B2BAPI.get('/receive', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateUser = async (userId, payload) => {
  try {
    const response = await B2BAPI.put(`/account/${userId}`, payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const createTemplate = async (payload) => {
  try {
    const response = await B2BAPI.post('/email-template', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateTemplate = async (templateId, payload) => {
  try {
    const response = await B2BAPI.put(`/email-template/${templateId}`, payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteTemplate = async (templateId) => {
  try {
    const response = await B2BAPI.delete(`/email-template/${templateId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteCampaign = async (campaignId) => {
  try {
    const response = await B2BAPI.delete(`/campaign/${campaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignReport = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.get(`/report/campaign/${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getAccountReport = async (b2bAccountId) => {
  try {
    const response = await B2BAPI.get(`/report/account/${b2bAccountId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const generateAiEmailTemplate = async (payload) => {
  try {
    const response = await B2BAPI.post('/email-template/auto-generate', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignFirms = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign-firms', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignFirmsAndState = async (params) => {
  try {
    const response = await B2BAPI.get('/campaign-firms-and-campaign-state', {
      params: {
        ...params
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateCampaignFirmSelection = async (payload) => {
  try {
    const response = await B2BAPI.post('/campaign-firms/selection', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const updateCampaignFirmEmailContent = async (payload) => {
  try {
    const response = await B2BAPI.post('/campaign-firms/email-content', payload)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const approveCampaignFirmSelection = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.post(`/campaign/approve?b2bCampaignId=${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const startMailing = async (b2bCampaignId) => {
  try {
    const response = await B2BAPI.post(`/campaign/start-mailing?b2bCampaignId=${b2bCampaignId}`)
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const testSendSettings = async (emailSettings) => {
  try {
    const response = await B2BAPI.post('/settings/send/test', { ...emailSettings })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const testReceiveSettings = async (emailSettings) => {
  try {
    const response = await B2BAPI.post('/settings/receive/test', { ...emailSettings })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(
        response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const downloadCampaignFirmsExcel = async (b2bCampaignId, selected = false, relevant = false) => {
  try {
    const response = await B2BAPI.get('/excel/campaign-firms', {
      params: { b2bCampaignId, selected, relevant },
      responseType: 'blob',
      headers: {
        Accept: 'application/octet-stream'
      }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const unsubscribe = async (token) => {
  try {
    const response = await B2BAPI.get(`/unsubscribe?token=${token}`)
    return response.status === 200 ? response.data : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const scrapeEmailGeneratorParameters = async (website) => {
  try {
    const response = await B2BAPI.get('/account/scrape-email-generator-parameters', {
      params: { website }
    })
    return response.status === 200
      ? Promise.resolve(response)
      : Promise.reject(response)
  } catch (error) {
    return Promise.reject(error)
  }
}
